import { useState } from "react";
import { Layers } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const CEFR = ["A1", "A2", "B1", "B2", "C1", "C2"];

// Same theme at other CEFR levels — compare inline; opening is an explicit choice and the current mission stays one click back.
export default function LevelLadder({ current, ladder, onOpen }) {
  const { t } = useI18n();
  const [peek, setPeek] = useState(null);
  if (!ladder?.length) return null;
  const rows = [...ladder, { ...current, self: true }].sort((a, b) => CEFR.indexOf(a.cefr) - CEFR.indexOf(b.cefr));
  const p = ladder.find((x) => x.mission_id === peek);
  return (
    <div className="nb-card bg-white p-3" data-testid="lib-ladder">
      <div className="text-xs font-bold flex items-center gap-1.5"><Layers className="w-3.5 h-3.5" /> {t("lib.ladder")}</div>
      <div className="flex flex-wrap gap-1.5 mt-2" dir="ltr">
        {rows.map((x) => x.self ? (
          <span key={x.mission_id} className="nb-tag bg-ink text-white text-xs" aria-current="true" data-testid="lib-ladder-current">{x.cefr} · {t("lib.thisMission")}</span>
        ) : (
          <button key={x.mission_id} onClick={() => setPeek(peek === x.mission_id ? null : x.mission_id)}
            className={`nb-tag text-xs ${peek === x.mission_id ? "bg-sky" : "bg-white"}`} data-testid={`lib-ladder-${x.cefr}`}>{x.cefr}</button>
        ))}
      </div>
      {p && (
        <div className="mt-2 border-t border-ink/10 pt-2 text-sm space-y-1" data-testid="lib-ladder-compare">
          <div className="font-bold" dir="ltr">{p.cefr} · {p.title}</div>
          <div className="text-xs text-gray-600" dir="ltr">{p.communication_mode} · {p.primary_skill} · {p.duration_min} min · {p.grouping}</div>
          <p className="text-xs" dir="ltr">{p.learning_objective}</p>
          <button onClick={() => onOpen(p.mission_id)} className="nb-btn-outline py-1 px-2 text-xs" data-testid="lib-ladder-open">{t("lib.openVersion")}</button>
        </div>
      )}
    </div>
  );
}
